const toggleSections = Array.from(document.querySelectorAll('.js-toggle-product'));
/* eslint-disable */
toggleSections.forEach((section) => {
    const accordion = Array.from(section.querySelectorAll('.product-accordion'));
    accordion.forEach((accordionHeader) => {
        accordionHeader.addEventListener('click', () => {
            document.getElementById(section.getAttribute('id')).classList.toggle('toggled');
        });
    });
});
